export const SET_COUNTRY = 'SET_COUNTRY';
export const SET_REGION = 'SET_REGION';
export const APPEND_COUNTRY = 'APPEND_COUNTRY';
export const SET_DISTRICT = 'SET_DISTRICT';
export const SET_TOWNSHIP = 'SET_TOWNSHIP';
